<template>
    <div id="app">
        <br class="visible-xs"/>
        <div class="christ-header text-center mt-">
            <img class="logo" alt="Rechtsanwalt Christ - Bochum" src="./assets/paragraph.png"/>
            <span class="title-title">Rechtsanwalt</span>
            <span class="title"> Christ</span>
        </div>
        <div class="navigation">
            <div class="navbar navbar-default hidden-sm hidden-xs">
                <div class="container">
                    <ul class="nav navbar-nav">
                        <li><a :class="isActive('am')" @click.prevent="selected = 'am'" href="#" class="navbar-c-brand">Über mich</a></li>
                    </ul>
                    <ul class="nav navbar-nav">
                        <li><a :class="isActive('for')" @click.prevent="selected = 'for'" href="#">Rechtsgebiete</a></li>
                        <li><a :class="isActive('lot')" @click.prevent="selected = 'lot'" href="#">Mietrecht</a></li>
                        <li><a :class="isActive('fl')" @click.prevent="selected = 'fl'" href="#">Familienrecht</a></li>
                        <li><a :class="isActive('cl')" @click.prevent="selected = 'cl'" href="#">Strafrecht</a></li>
                    </ul>
                    <ul class="nav navbar-nav pull-right">
                        <li><a :class="isActive('contact')" @click.prevent="selected = 'contact'" href="#">Kontakt</a></li>
                        <li><a :class="isActive('home')" @click.prevent="selected = 'home'" href="#">
                            <font-awesome-icon icon="home" />
                        </a>
                        </li>
                    </ul>
                </div>
            </div>
            <responsive-nav ref="respnav">
                <div class="mt-3 ml-2">
                    <img class="logo-responsive-nav" alt="Rechtsanwalt Christ - Bochum" src="./assets/paragraph.png"/><span
                        class="title-title-responsive-nav">Rechtsanwalt</span><span class="title-responsive-nav"> Christ</span>
                </div>
                <ul class="nav">
                    <li><a :class="isActive('home')" @click.prevent="setSelected('home')" href="#">Home</a></li>
                    <li><a :class="isActive('am')" @click.prevent="setSelected('am')" href="#">Über mich</a></li>
                    <li><a :class="isActive('for')" @click.prevent="setSelected('for')" href="#">Rechtsgebiete</a></li>
                    <li><a :class="isActive('lot')" @click.prevent="setSelected('lot')" href="#">Mietrecht</a></li>
                    <li><a :class="isActive('fl')" @click.prevent="setSelected('fl')" href="#">Familienrecht</a></li>
                    <li><a :class="isActive('cl')" @click.prevent="setSelected('cl')" href="#">Strafrecht</a></li>
                    <li><a :class="isActive('contact')" @click.prevent="setSelected('contact')" href="#">Kontakt</a></li>
                    <li><a :class="isActive('pp')" @click.prevent="setSelected('pp')" href="#">Datenschutz</a></li>
                    <li><a :class="isActive('ln')" @click.prevent="setSelected('ln')" href="#">Impressum</a></li>
                </ul>
            </responsive-nav>
        </div>
        <div class="mt-5 mb-5 pt-5 pb-3 visible-md visible-lg">
            <hr class="hr-top"/>
        </div>
        <div class="mt-2 pt-2 pb-5 visible-sm">
            <hr class="hr-top"/>
        </div>
        <div class="mt-2 pt-2 pb-3 visible-xs">
            <hr class="hr-top"/>
        </div>

        <div class="content container">
            <ContentRouter v-bind:selected="selected" v-on:routeTo="routeTo"/>
        </div>
        <div class="mt-5 mb-5 pt-5 pb-5">
            <hr class="hr-top"/>
        </div>
        <div class="footer hidden-sm hidden-xs">
            <div class="navbar navbar-default hidden-sm hidden-xs">
                <div class="container">
                    <ul class="nav navbar-nav">
                        <li><a :class="isActive('home')" @click.prevent="selected = 'home'" href="#">Home</a></li>
                        <li><a :class="isActive('pp')" @click.prevent="selected = 'pp'" href="#">Datenschutz</a></li>
                        <li><a :class="isActive('ln')" @click.prevent="selected = 'ln'" href="#">Impressum</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import ResponsiveNav from "./components/ResponsiveNav";
    import ContentRouter from "./components/ContentRouter";

    export default {
        name: 'App',
        components: {
            ResponsiveNav,
            ContentRouter,
        },
        data() {
            return {
                selected: "home"
            }
        },
        methods: {
            routeTo(page) {
                this.selected = page;
                this.scrollToTop(200);
            },
            isActive(link) {
                return (this.selected === link) ? 'active' : '';
            },
            setSelected(page){
                this.routeTo(page);
                this.$refs.respnav.toggleActive(false, true);
            },
            scrollToTop(duration){
                // cancel if already on top
                if (document.scrollingElement.scrollTop === 0) return;

                const totalScrollDistance = document.scrollingElement.scrollTop;
                let scrollY = totalScrollDistance, oldTimestamp = null;

                function step (newTimestamp) {
                    if (oldTimestamp !== null) {
                        // if duration is 0 scrollY will be -Infinity
                        scrollY -= totalScrollDistance * (newTimestamp - oldTimestamp) / duration;
                        if (scrollY <= 0) return document.scrollingElement.scrollTop = 0;
                        document.scrollingElement.scrollTop = scrollY;
                    }
                    oldTimestamp = newTimestamp;
                    window.requestAnimationFrame(step);
                }
                window.requestAnimationFrame(step);
            }
        }
    }
</script>

<style>
    @import "css/c-style.css";

    html {
        background: linear-gradient(135deg, #fdfcfb 0%, #e2d1c3 100%, #fdfcfb 0%);
        min-height: 100%;
    }

    .title-title {
        font-size: 3.5rem !important;
        font-family: Georgia, Tahoma, serif, sans-serif !important;
    }

    .title-title-responsive-nav {
        font-size: 2.5rem !important;
        font-family: Georgia, Tahoma, serif, sans-serif !important;
    }

    .title {
        font-size: 3rem !important;
        font-family: Georgia, Tahoma, serif, sans-serif !important;
    }

    .title-responsive-nav {
        font-size: 2rem !important;
        font-family: Georgia, Tahoma, serif, sans-serif !important;
    }

    .logo {
        height: 35px;
        margin-bottom: 20px;
    }

    .logo-responsive-nav {
        height: 25px;
        margin-bottom: 12px;
    }

    .navbar-nav {
        flex-direction: row !important;
    }

    .navbar-default {
        background: linear-gradient(1deg, #e2d1c3 0%, #fdfcfb 100%, #e2d1c3 0%);
    }

    .navbar-brand {
        padding-top: 15px !important;
    }

    body {
        font-family: Arial, Helvetica, sans-serif !important;
        font-size: 1.8rem !important;
        margin-bottom: 50px !important;
        background: transparent;
        background-color: transparent !important;
        min-height: 100%;
    }

    .nav.navbar-nav {
        font-size: 1.7rem !important;
    }

    .navbar-c-brand {
    }

    .hr-top {
        background: linear-gradient(to right, white, black, lightgray);
        height: 1px;
        border: none;
        width: 95%;
    }

    @media (max-width: 739px) {
        .hr-top {
            width: 90%;
        }
    }

    ul.fields-of-law {
        padding-inline-start: 16px;
    }

    ul.fields-of-law li {
        list-style: none;
        height: 30px;
    }

    ul.fields-of-law li:before {
        content: '';
        display: inline-block;
        height: 18px;
        width: 1.1em;
        margin-bottom: -1px;
        background-image: url('./assets/paragraph.png');
        background-size: contain;
        background-repeat: no-repeat;
    }

    .pl-7px {
        padding-left: 7px;
    }

    a {
        color: darkslategrey !important;
    }

    a:hover {
        color: black !important;
        text-decoration: none !important;
        text-shadow: 3px 3px 5px #777;
    }

    a.active {
        color: black !important;
        text-shadow: 3px 3px 5px #777;
    }

    .footer {
        position: fixed;
        height: 60px;
        background-color: white;
        bottom: 0px;
        left: 0px;
        right: 0px;
        margin-bottom: 0px;
    }

    @media (max-width: 414px){
    .center-sm{
        text-align: center;
    }
        .margin-sm{
            margin-left: 26%;
        }
        .mt-sm-30 {
            margin-top: 30px;
        }
    }

</style>
